import { render, staticRenderFns } from "./PairedSubscriptionCard.vue?vue&type=template&id=22a9c760&scoped=true&"
import script from "./PairedSubscriptionCard.vue?vue&type=script&lang=js&"
export * from "./PairedSubscriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./PairedSubscriptionCard.vue?vue&type=style&index=0&id=22a9c760&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a9c760",
  null
  
)

export default component.exports